import React from 'react';
import { css } from '@emotion/react';

import { Link, useParams } from 'react-router-dom';
import { useQuery } from 'urql';
import { ArtistForm } from './forms/ArtistForm';
import { Header } from 'screens/booker/components/Header';
import { Heading } from 'screens/booker/components/Heading';
import { routes } from 'routes';
import { Spinner } from 'components/Spinner';
import { QUERY_BOOKER_ARTIST } from 'queries/queries-booker';
import { SpinnerBlock } from 'components/SpinnerBlock';
import { theme } from 'styles/theme';
import { AnimationPulse } from 'styles/animations';
import slugify from '@sindresorhus/slugify';

export const ScreenEditArtist = () => {
	const { id } = useParams();

	const [request, executeRequest] = useQuery({
		query: QUERY_BOOKER_ARTIST,
		variables: { id: id },
	});

	const { data, fetching } = request;

	// const fetching = true;

	return (
		<div>
			<Header>
				<Heading
					left={
						<div>
							{/* <Link to={routes.booker.artist}>{'<-'} Zpět</Link> */}

							<h1
								css={css`
									font-size: 24px;
									line-height: 36px;
									font-weight: normal;
									margin-bottom: 0;
									// margin-top: 16px;

									display: flex;
									align-items: center;
									gap: 12px;
								`}
							>
								<Link
									to={routes.booker.artist}
									css={css`
										color: ${theme.color.text[300]};

										&:hover {
											text-decoration: none;
										}
									`}
								>
									Interpreti
								</Link>
								<span
									css={css`
										color: ${theme.color.text[300]};
									`}
								>
									-&gt;
								</span>
								{!fetching && data && (
									<div
										css={css`
											display: flex;
											align-items: center;
											gap: 12px;
										`}
									>
										<img
											src={
												process.env.ASSETS_URL + 'artists/' + slugify(data?.artist?.url) + '.png'
											}
											css={css`
												border-radius: 12px;
												width: 32px;
												flex-shrink: 0;
											`}
										/>
										<div>{data?.artist?.name}</div>
									</div>
								)}
								{fetching && (
									<span
										css={css`
											display: inline-block;
											background: #e2e3e9;
											border-radius: 8px;
											width: 100px;
											height: 12px;

											animation: ${AnimationPulse()} 2s infinite;
										`}
									></span>
								)}
							</h1>
						</div>
					}
				></Heading>
			</Header>
			<div
				css={css`
					display: flex;
					padding: 32px;
					width: 580px;
					flex-direction: column;
				`}
			>
				{fetching ? (
					<SpinnerBlock />
				) : data && !data?.artist ? (
					'neexistuje'
				) : (
					<ArtistForm defaultValues={data?.artist} id={data?.artist?.id} />
				)}
			</div>
		</div>
	);
};
